<template>
  <el-container>
    <el-main>
      <el-row style="margin-bottom: 20px; width: 100%">基本设置</el-row>
      <el-row>
        <el-form ref="form" :model="stObj" :rules="rules" label-position="right" label-width="110px">
          <template v-if="stObj.tx !== '9'">
            <el-form-item label="题干" prop="tg" :rules="[{validator: tgValidator, trigger: 'change'}]">
              <!--
                <el-input type="textarea" v-model="stObj.tg" style="width:400px" placeholder="请输入题干"></el-input>
              -->
              <div class="editorDiv" id="stnr"></div>
              <div class="editorBox" v-html="stObj.stnr || stObj.tg || '<br/>'" @click="showEditor('stnr', stObj)"></div>
            </el-form-item>
            <!-- 单选题 -->
            <template v-if="stObj.tx === '1'">
              <el-form-item label=" " class="xxDiv" v-for="(ksySjkStxx, stxxIdx) in stObj.ksySjkStxxList" :key="stxxIdx" style="width:100%; margin-bottom: 8;">
                <el-radio v-model="stObj.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" :class="'box-'+stObj.stid+'-'+stxxIdx" style="margin-right: 0;  width: 50px;">
                  {{options[stxxIdx]}}.
                </el-radio>
                <div class="editorDiv" style="width: 90%;" :id="'xxnr' + stxxIdx"></div>
                <div class="editorBox" style="width: 89%;" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm || '<br/>'" @click="showEditor('xxnr' + stxxIdx, ksySjkStxx, 'xxnr', 100)"></div>
                <el-row class="xxHandle handle">
                  <!--
                    <span title="删除" @click="edit(stObj.stid, stxxIdx, true)"><i class="el-icon-edit-outline"></i></span>
                  -->
                  <span v-show="stObj.ksySjkStxxList.length > 2" style="color: red;" title="删除" @click="remove(stObj.ksySjkStxxList, stxxIdx, stObj.ksySjkStda.ksda === ksySjkStxx.xxid + '')"><i class="el-icon-delete-solid"></i></span>
                </el-row>
                <!--
                  <el-input :class="'input-'+stObj.stid+'-'+stxxIdx" v-model="ksySjkStxx.xxsm" style="display:none" @keyup.enter.native="edit(stObj.stid, stxxIdx, false)" @blur="edit(stObj.stid, stxxIdx, false)"></el-input>
                -->
              </el-form-item>
              <el-form-item style="padding-left: 0px">
                <el-button style="width: 300px" @click="addXx(stObj.ksySjkStxxList)"><i class="el-icon-plus">&emsp;添加选项</i></el-button>
              </el-form-item>
            </template>
            <!-- 多选题 -->
            <template v-if="stObj.tx === '2'">
              <el-form-item label=" " class="xxDiv" v-for="(ksySjkStxx, stxxIdx) in stObj.ksySjkStxxList" :key="stxxIdx" style="width:100%; margin-bottom: 8;">
                <el-checkbox v-model="stObj.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" :class="'box-'+stObj.stid+'-'+stxxIdx" >
                  {{options[stxxIdx]}}.
                </el-checkbox>
                <div class="editorDiv" style="width: 90%;" :id="'xxnr' + stxxIdx"></div>
                <div class="editorBox" style="width: 89%;" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm || '<br/>'" @click="showEditor('xxnr' + stxxIdx, ksySjkStxx, 'xxnr', 100)"></div>
                <el-row class="xxHandle handle">
                  <!--
                    <span title="删除" @click="edit(stObj.stid, stxxIdx, true)"><i class="el-icon-edit-outline"></i></span>
                  -->
                  <span v-show="stObj.ksySjkStxxList.length > 2" style="color: red;" title="删除" @click="remove(stObj.ksySjkStxxList, stxxIdx, stObj.ksySjkStda.ksda.includes(ksySjkStxx.xxid + ''))"><i class="el-icon-delete-solid"></i></span>
                </el-row>
                <!--
                  <el-input :class="'input-'+stObj.stid+'-'+stxxIdx" v-model="ksySjkStxx.xxsm" style="display:none" @keyup.enter.native="edit(stObj.stid, stxxIdx, false)" @blur="edit(stObj.stid, stxxIdx, false)"></el-input>
                -->
              </el-form-item>
              <el-form-item style="text-align: center;; width: 100%">
                <el-button type="primary" style="width: 300px" @click="addXx(stObj.ksySjkStxxList)">添加选项</el-button>
              </el-form-item>
            </template>
            <!-- 填空题 -->
            <template v-if="stObj.tx === '3'">
              <el-form-item v-for="(da, index) in stObj.ksySjkStda.ksda" :key="index" :label="'答案'+(index+1)" class="xxDiv">
                <el-input v-model="stObj.ksySjkStda.ksda[index]" style="width:400px" placeholder=""></el-input>
                <el-row class="xxHandle handle">
                  <span style="color: red;" title="删除" @click="remove(stObj.ksySjkStda.ksda, index)"><i class="el-icon-delete-solid"></i></span>
                </el-row>
              </el-form-item>
              <el-form-item style="text-align: center;; width: 100%">
                <el-button type="primary" style="width: 300px" @click="stObj.ksySjkStda.ksda.push('')">添加填空项</el-button>
              </el-form-item>
            </template>
            <!-- 判断题 -->
            <template v-if="stObj.tx === '4'">
              <el-radio-group v-model="stObj.ksySjkStda.ksda">
                <el-form-item label=" " class="xxDiv" v-for="(ksySjkStxx, stxxIdx) in stObj.ksySjkStxxList" :key="stxxIdx">
                  <el-radio :label="ksySjkStxx.xxid + ''" :class="'box-'+stObj.stid+'-'+stxxIdx" >
                    {{ksySjkStxx.xxsm}}
                  </el-radio>
                  <el-row class="xxHandle handle">
                    <span style="color: red;" title="删除" @click="edit(stObj.stid, stxxIdx, true)"><i class="el-icon-edit-outline"></i></span>
                  </el-row>
                  <el-input :class="'input-'+stObj.stid+'-'+stxxIdx" v-model="ksySjkStxx.xxsm" style="display:none" @keyup.enter.native="edit(stObj.stid, stxxIdx, false)" @blur="edit(stObj.stid, stxxIdx, false)"></el-input>
                </el-form-item>
              </el-radio-group>
            </template>
            <!-- 问答题 -->
            <template v-if="stObj.tx === '5'">
              <el-form-item label="答案">
                <!--
                  <el-input v-model="stObj.ksySjkStda.ksda" type="textarea" :autosize="{ minRows: 5, maxRows: 20 }" style="width:400px" placeholder=""></el-input>
                -->
                <div class="editorDiv" id="ksda"></div>
                <div class="editorBox" v-html="stObj.ksySjkStda.ksda || '<br/>'" @click="showEditor('ksda', stObj.ksySjkStda)"></div>
              </el-form-item>
            </template>
            <!-- 问答题 -->
            <template v-if="stObj.tx === '6'">
              <el-form-item label="答案">
                <!--
                  <el-input v-model="stObj.ksySjkStda.ksda" type="textarea" :autosize="{ minRows: 5, maxRows: 20 }" style="width:400px" placeholder=""></el-input>
                -->
                <div class="editorDiv" id="ksda"></div>
                <div class="editorBox" v-html="stObj.ksySjkStda.ksda || '<br/>'" @click="showEditor('ksda', stObj.ksySjkStda)"></div>
              </el-form-item>
            </template>
            <el-form-item label="解析">
              <!--
                <el-input type="textarea" v-model="stObj.ksySjkStda.dajx" style="width:400px" placeholder="请输入答案解析"></el-input>
              -->
              <div class="editorDiv" id="dajx"></div>
              <div class="editorBox" v-html="stObj.ksySjkStda.dajx || '<br/>'" @click="showEditor('dajx', stObj.ksySjkStda)"></div>
            </el-form-item>
          </template>
          <el-form-item style="text-align: center; width: 100%">
            <el-button type="primary" style="width: 200px" @click="submitForm">确定</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import wangeditor from '@/assets/js/editor/wangeditor.js'
export default {
  data () {
    return {
      editors: {}, // 富文本编辑器
      options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      rules: {}
    }
  },
  props: {
    stObj: Object,
    visible: Boolean
  },
  watch: {
    'stObj.ksySjkStda.ksda': {
      handler (val, oldVal) {
        if (Array.isArray(val)) {
          this.stObj.ksySjkStda.bzda = val.join('€')
        } else {
          this.stObj.ksySjkStda.bzda = val
        }
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    tgValidator (rule, value, callback) {
      if (!this.stObj.tg && !this.stObj.stnr) {
        callback(new Error('请输入试题题干'))
      } else {
        callback()
      }
    },
    showEditor (divId, obj = this, key = divId, height = 200) {
      const that = this
      // 收缩其它富文本编辑器
      const otherEditorDivs = document.querySelectorAll('.editorDiv:not([id=' + divId + '])')
      otherEditorDivs.forEach(editorDiv => {
        editorDiv.nextElementSibling.style.display = 'inline-block'
        editorDiv.style.display = 'none'
      })
      // 显示当前富文本编辑器
      const editorDiv = document.getElementById(divId)
      editorDiv.nextElementSibling.style.display = 'none'
      editorDiv.style.display = 'inline-block'
      const isEditor = editorDiv.getAttribute('data-isEditor')
      // 初始化富文本编辑器
      if (!isEditor) {
        // 定义改变事件
        const config = {
          onchange: function (newHtml) {
            obj[key] = newHtml
            if (key.indexOf('stnr') !== -1) {
              obj.tg = that.editors[divId].txt.text()
            } else if (key.indexOf('xxnr') !== -1) {
              obj.xxsm = that.editors[divId].txt.text()
            }
          },
          height: height
        }
        // 创建富文本框
        this.editors[divId] = wangeditor.createComplexEditor(editorDiv, config)
        if (key.indexOf('stnr') !== -1) {
          this.editors[divId].txt.html(obj[key] || obj.tg)
        } else if (key.indexOf('xxnr') !== -1) {
          this.editors[divId].txt.html(obj[key] || obj.xxsm)
        } else {
          this.editors[divId].txt.html(obj[key])
        }
        editorDiv.setAttribute('data-isEditor', true)
      }
    },
    addXx (xxList) {
      const length = xxList.length
      const lastStxx = xxList[length - 1]
      let maxXsxh = Math.max(...xxList.map(stxx => stxx.xsxh || 0))
      maxXsxh = maxXsxh === -Infinity ? 0 : maxXsxh
      const stxx = {}
      Object.assign(stxx, lastStxx)
      stxx.xxid = lastStxx.xxid + 1
      stxx.xsxh = maxXsxh + 1
      stxx.xxsm = '选项' + (length + 1)
      stxx.xxnr = '选项' + (length + 1)
      xxList.push(stxx)
    },
    // 编辑选项
    /*
    edit (stid, index, isEdit) {
      const boxId = '.box-' + stid + '-' + index
      const inputId = '.input-' + stid + '-' + index
      if (isEdit) {
        document.querySelector(boxId).style.display = 'none'
        document.querySelector(inputId).style.display = 'block'
        document.querySelector(inputId).querySelector('.el-input__inner').focus()
      } else {
        document.querySelector(boxId).style.display = 'block'
        document.querySelector(inputId).style.display = 'none'
      }
    },
    */
    remove (list, index, isBzda) {
      if (isBzda) {
        this.$message.warning('不能删除标准答案')
        return
      }
      list.splice(index, 1)
      // 重新排序
      for (let i = 0; i < list.length; i++) {
        list[i].xsxh = i + 1
      }
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('update:visible', false)
        } else {
          return false
        }
      })
    }
  },
  created () {}
}
</script>
<style scoped>
  .formItem{
    margin-left: 10px
  }
  .xxDiv {
    margin-bottom: 10px;
    width: 600px;
  }
  .xxDiv:hover .xxHandle {
    display: block;
  }
  .xxHandle {
    display: none;
    position: absolute;
    right: -25px;
    top: 0px;
    z-index: 999;
  }
  .handle span {
    margin: 0 10px;
    font-size: 20px;
    color: #409EFF;
  }
  .handle span:hover {
    cursor: pointer;
  }
</style>
